import React, { useState } from 'react'
import { SafeAreaView } from 'react-native-safe-area-context'
import { View, StyleSheet, Platform } from 'react-native'
import { Description, Space, Button, AnimatedEllipsis, Text, CheckBox, Label } from '@sart/components'
import { adaptive, backgroundColors, typography, colors } from '@sart/styles'
import client, { useData } from '@sart/client'
import { useContent } from '@sart/content'
import { testID } from '@sart/utilities'
import delay from 'delay'

export default function CancelServiceConfirmation(props) {
  const { navigation, route } = props
  const currentPlan = route.params?.currentPlan
  const [{ settings, submitting, error }, setData] = useData({ submitting: false })
  const content = useContent()
  const [acknowledgement, setAcknowledgement] = React.useState(false)

  async function handleSubmit(values, form) {

    setData({ submitting: true, error: null })

    try {
      console.log('Cancellation confirmed - cancelling: ' + currentPlan.product.productName)

      const order = await client.checkoutServiceDelProduct(currentPlan.product)
      console.log('order response from cancelling recurring add-on: ' + JSON.stringify(order, null, 2))

      /*
      const order = {
        "status": "successful"
      }
      */
      
      if(order.status && order.status === "successful") {
        const confirmation = {
          title: content.common.cancelled,
          description: `${currentPlan.product.productName} ${content.dashboard.cancelSuccessful}`
        }
        navigation.navigate('Confirmation', {confirmation})
      } else {
        setData({ submitting: false, error: 'Cancellation failed. Please try again later or contact support' })
        console.log("error = " + error)
      }

      await delay(2000)

      setData({ submitting: false })

    } catch (e) {
      console.log("error catch: " + JSON.stringify(e, null, 2))
      setData({ submitting: false, error: e.message || 'An unexpected error occurred. Please try again later or contact support' })
      return
    }

  }

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.widthRestrictions}>
        <Description style={styles.descriptionStyle}>{content.cancel.infoConfirmationIntro}</Description>
        <Description style={styles.descriptionStyle}>{content.cancel.infoConfirmationPoint1}</Description>
        <Description style={styles.descriptionStyle}>{content.cancel.infoConfirmationPoint2}</Description>
        <Description style={styles.descriptionStyle}>{content.cancel.infoConfirmationPoint3}</Description>
        <Space height={20} />

        <View style={styles.checkboxWrapper}>
          <CheckBox
            value={acknowledgement}
            onPress={() => setAcknowledgement(!acknowledgement)}
            webSize={14}
            style={styles.checkbox}
            tintColors={{ true: colors.brightOrange, false: colors.white }}
            checkedColor={colors.brightOrange}
            borderColor={colors.brightOrange}
            disabledBorderColor={colors.white}
            tickColor={colors.white}
            //disabled={changingCommunicationPreference}
            {...testID('CancelSubscritiptionAcknowledgement')}
          />
          <Space width={12} />
          <Label style={styles.descriptionStyle}>{content.cancel.acknowledgeLabel}</Label>
        </View>

        <Space height={20} />
        <Button
          title={
            submitting
              ? <AnimatedEllipsis style={{fontSize:24, color:colors.clear, ...typography.extrabold}}/>
              : content.cancel.confirm
          }
          disabled={!(acknowledgement && !submitting)}
          onPress={handleSubmit}
          style={styles.enabledButton}
          disabledStyle={styles.disabledButton}
          titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
          disabledTitleStyle={{...typography.extrabold, fontSize: 18, color: colors.white + 45}}  
          {...testID('cancelServiceConfirmation')}      
        />
          {error &&
            <Text style={styles.errorText}>
              {error}
            </Text>
          }
      </View>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 24,
    paddingBottom: 0,
    backgroundColor: backgroundColors.darkCharcoal,
    ...adaptive.wrapperPadding,
    ...Platform.select({
      web: {
        alignItems: 'center'
      }
    })
  },
  descriptionStyle: {
    fontSize: 16,
    lineHeight: 26,
    color: colors.white,
    ...typography.demi,
  },
  checkboxWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
    maxWidth: '80%'
  },
  enabledButton: {
    backgroundColor: colors.brightOrange,
  },
  disabledButton: {
    backgroundColor: colors.brightOrange + 50
  },
  errorText: {
    color: 'red',
    marginTop: 4,
    marginBottom: 16,
  },
  widthRestrictions: {
    width: '100%',
    maxWidth: 600,
    paddingBottom: 40
  }
})